<template>
  <form class="form" method="post">

    <div id="appPublicationCreateVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <h2>Ajouter une publication Web</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Titre*</p>
            <p for="file" class="appLabelStyle1">Image</p>
            <p class="appLabelStyle1">Mon texte*</p>
          </div>
          <div class="appGroupOfInput">
            <input v-model="title" type="string" name="title" class="appInputStyle1" placeholder="Saisir mon titre ici">
            <input @change="onFileChange()" class="appInputStyle1 appPublicationFileInpout" type="file" ref="file"
              name="file" accept=".jpg, .jpeg, .gif, .png">
            <textarea v-model="description" type="string" name="description" class="appInputStyle3"
              placeholder="Saisir ma description ici"></textarea>
          </div>
        </div>
      </div>
      <p class="appInputStyle1 appStatisticsTable04">Ne pas faire de saut à la ligne, ou indiquer de "," ou de ":"</p>
      <br>
      <button @click.prevent="createPublication()" type="submit" class="appButtonModel2">Ajouter ma publication</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'PublicationCreate',
  data () {
    return {
      date: '',
      title: '',
      description: '',
      imageUrl: '',
      errorMsg: ''
    }
  },
  methods: {
    onFileChange () {
      this.file = this.$refs.file.files[0]
      this.newImage = URL.createObjectURL(this.file)
    },
    createPublication () {
      if (this.title !== null || this.description !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        // Gestion de la Formdata
        const myForm = new FormData()
        const myDataToCreatePost = {
          'userId': decryptedToken.userId,
          'date': new Date().toLocaleDateString('fr'),
          'title': this.title,
          'description': this.description
        }
        myForm.append('article', JSON.stringify(myDataToCreatePost))
        // Partie Image
        const file = this.file
        myForm.append('image', file)
        // Partie Post
        axios
          .post('https://privilegia.fr/api/articles', myForm, {
            headers: {
              Authorization: 'Bearer ' + tokenWithDatas.token,
              'Content-type': 'multipart/form-data'}
          })
          .then((response) => {
            window.alert('Nouvel article web ajouté')
            this.$router.push('/App/Publications')
          })
          .catch((error) => {
            console.log(error.response.data)
            this.errorMsg = 'Merci de renseigner un titre et une description'
          })
          // Si des champs sont vides
      } else {
        this.errorMsg = 'Merci de renseigner un titre et une description'
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppPublicationsCreate.vue